/*
 * MCRO001-F0050 / T-MCRO-050 — the `comment` kind renderer.
 * Read-only render of an anchored annotation: its body, and (if present) the two versions
 * it references. No resolution affordance ever.
 */

import React from 'react';

export default function CommentViewer({ node }) {
  const title = node?.title || 'Comment';
  const hasVersions = node?.ours !== undefined || node?.theirs !== undefined;
  return (
    <section
      className="annotation-viewer annotation-viewer--comment"
      role="region"
      aria-label={title}
      data-annotation-kind={node?.kind}
      style={BOX_STYLE}
    >
      <header style={BORDER_LABEL_STYLE}>{title}</header>
      {node?.body ? (
        <pre style={TEXT_STYLE} data-testid="comment-body">{node.body}</pre>
      ) : null}
      {hasVersions ? (
        <div style={SIDES_STYLE}>
          <figure style={SIDE_STYLE}>
            <figcaption style={CAPTION_STYLE}>My version</figcaption>
            <pre style={TEXT_STYLE} data-testid="comment-ours">{node?.ours ?? ''}</pre>
          </figure>
          <figure style={SIDE_STYLE}>
            <figcaption style={CAPTION_STYLE}>Their version</figcaption>
            <pre style={TEXT_STYLE} data-testid="comment-theirs">{node?.theirs ?? ''}</pre>
          </figure>
        </div>
      ) : null}
    </section>
  );
}

const BOX_STYLE = { border: '1px solid currentColor', borderRadius: '4px', padding: '0.5rem', margin: '0.25rem 0' };
const BORDER_LABEL_STYLE = { fontWeight: 600, marginBottom: '0.25rem' };
const SIDES_STYLE = { display: 'flex', flexWrap: 'wrap', gap: '0.5rem' };
const SIDE_STYLE = { flex: '1 1 12rem', border: '1px solid currentColor', borderRadius: '4px', padding: '0.25rem', margin: 0 };
const CAPTION_STYLE = { fontWeight: 600 };
const TEXT_STYLE = { whiteSpace: 'pre-wrap', margin: '0.25rem 0 0', fontFamily: 'inherit' };
